import { render, staticRenderFns } from "./roleLimits.vue?vue&type=template&id=53528ae4&"
import script from "./roleLimits.vue?vue&type=script&lang=js&"
export * from "./roleLimits.vue?vue&type=script&lang=js&"
import style0 from "./roleLimits.vue?vue&type=style&index=0&id=53528ae4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports